export default __webpack_public_path__ + "static/media/slash.cdb84baf.svg";